module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_5033_gold.1c9f7007.jpg";